(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anbu-character-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-anbu-zoom]');
    if (trigger) {
      openAnbuLightbox(trigger);
      return;
    }
    if (e.target.closest('[data-anbu-lightbox-close]')) {
      closeAnbuLightbox();
    }
  });

  document.addEventListener('keydown', function (e) {
    var focused = document.activeElement;
    if (e.key === 'Enter' && focused && focused.hasAttribute('data-anbu-zoom')) {
      openAnbuLightbox(focused);
    }
    if (e.key === 'Escape') {
      closeAnbuLightbox();
    }
  });

  function openAnbuLightbox(trigger) {
    var lightbox = trigger.closest('.anbu-section').querySelector('[data-anbu-lightbox]');
    if (!lightbox) return;
    var img = lightbox.querySelector('[data-anbu-lightbox-img]');
    var caption = lightbox.querySelector('[data-anbu-lightbox-caption]');
    img.src = trigger.getAttribute('data-zoom-src');
    img.alt = trigger.getAttribute('data-zoom-name') || '';
    caption.textContent = trigger.getAttribute('data-zoom-name') || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeAnbuLightbox() {
    document.querySelectorAll('[data-anbu-lightbox].is-open').forEach(function (lightbox) {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      var img = lightbox.querySelector('[data-anbu-lightbox-img]');
      if (img) img.src = '';
    });
    document.body.style.overflow = '';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anbu-cross-sell"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var openTrigger = e.target.closest('[data-anbu-modal-open]');
  if (openTrigger) {
    var modal = document.getElementById(openTrigger.getAttribute('data-anbu-modal-open'));
    if (modal) {
      modal.classList.add('is-open');
      document.body.classList.add('anbu-modal-lock');
      var input = modal.querySelector('.anbu-notify-input');
      if (input) setTimeout(function () { input.focus(); }, 150);
    }
    return;
  }

  var closeTrigger = e.target.closest('[data-anbu-modal-close]');
  if (closeTrigger) {
    var modal = closeTrigger.closest('.anbu-notify-modal');
    if (modal) {
      modal.classList.remove('is-open');
      document.body.classList.remove('anbu-modal-lock');
    }
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.anbu-notify-modal.is-open').forEach(function (m) {
      m.classList.remove('is-open');
    });
    document.body.classList.remove('anbu-modal-lock');
  }
});

document.addEventListener('submit', function (e) {
  var form = e.target.closest('[data-anbu-notify-form]');
  if (!form) return;
  e.preventDefault();

  var submitBtn = form.querySelector('.anbu-notify-submit');
  var submitText = submitBtn.querySelector('.anbu-notify-submit-text');
  var originalText = submitText.textContent;
  submitText.textContent = 'Sending...';
  submitBtn.disabled = true;

  var formData = new FormData(form);

  fetch(form.action, { method: 'POST', body: formData })
    .then(function () {
      var dialog = form.closest('.anbu-notify-dialog');
      dialog.querySelector('.anbu-notify-content').hidden = true;
      dialog.querySelector('.anbu-notify-success').hidden = false;
    })
    .catch(function () {
      submitText.textContent = originalText;
      submitBtn.disabled = false;
      alert('Something went wrong. Please try again.');
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
